export default __webpack_public_path__ + "static/media/landing-agent-feature-5.ee379deb.svg";